import type { Action } from "../../actions/types";

export type StoreState = string | null;

export const initialState = null;

export function reducer(
  state: StoreState = initialState,
  action: Action
): StoreState {
  if (action.type === "SET_EXCHANGE_ID") {
    return null as StoreState;
  }

  if (action.type === "EXCHANGE_REDEEM_SUCCESS") {
    return action.response.data.transaction.transaction.id;
  }

  return state;
}
